import React from "react";
import TTSContextForm from "../form/TTSContextForm/TTSContextForm";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Context" : "Create Context";
};

const TTSContextPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
  contextType,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <TTSContextForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
        contextType={contextType}
      />
    </RightSideModel>
  );
};

export default TTSContextPopup;
